module.exports = __webpack_public_path__ + "static/media/case1B.b2e2b7d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case1B.mp4
// module id = ZIdi
// module chunks = 0